<div
  class="file-dropzone"
  [class.file-dropzone--dragging]="isDragging"
  role="button"
  tabindex="0"
  (click)="openDialog()"
  (keydown)="onKeydown($event)"
  (dragover)="onDragover($event)"
  (dragleave)="onDragleave()"
  (drop)="onDrop($event)"
>
  <span class="file-dropzone__icon-wrap">
    <mat-icon class="file-dropzone__icon" [fontIcon]="iconName"></mat-icon>
  </span>
  @if (isDragging) {
    <span class="file-dropzone__label file-dropzone__label--release">
      {{ dropReleaseKey | translate }}
    </span>
  } @else {
    <span class="file-dropzone__label">
      {{ dropLabelKey | translate }}
    </span>
  }
  <span class="file-dropzone__limits">{{ limitsKey | translate }}</span>
</div>
<input
  #fileInput
  type="file"
  class="file-dropzone__input"
  [accept]="accept"
  (change)="onFileChange($event)"
  tabindex="-1"
  aria-hidden="true"
/>
